import React, { Component } from 'react';
import OrderManagementForm from '../OrderManagementForm';
import OrderAudit from '../OrderAudit/OrderAudit';
import { getBatchTypes, getBatchStatuses } from '../../../../../../Redux/Actions/CommonActions';
import IsLoading from '../../../../../Shared/Loading/IsLoading';

class DialogContainer extends Component {
    constructor(props) {
        super(props);
        let d = { ...this.props.dataItem };
        this.state = {
            view: "details",
            data: Object.keys(this.props.dataItem).length === 0 ? null : d
        };
    }

    changeVeiw = (view) => {
        this.setState({
            view: view
        })
    }

    render() {
        return (
            <div className="k-window-content">
                <div className="row " style={{ width: '100%' }}>
                    <div className="col-md-2 larger-font">
                        {this.state.data ?
                            <ul className="subSideNav">
                                <li onClick={() => this.changeVeiw("details")} className={this.state.view === "edit" ? "active" : ""}>Order Details</li>
                                <li onClick={() => this.changeVeiw("audit")} className={this.state.view === "add" ? "active" : ""}>Audit History</li>
                            </ul>
                            : ""}
                    </div>
                    <div className="col-md-10">
                        {this.state.view === "details" ?
                            <OrderManagementForm
                                dataItem={this.props.dataItem}
                                cancel={this.props.cancel}
                                updateOrder={this.props.updateOrder}
                            />
                             : ""}
                        {this.state.view === "audit" ?
                            <OrderAudit
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                            />
                            : ""}
                    </div>
                </div>
            </div>
        );
    }
}

export default DialogContainer;

